import {
    Autocomplete,
    Button,
    Card,
    CardContent,
    Grid,
    Divider, Table,
    MenuItem,
    TextField,
    Typography,
    TextareaAutosize,
    FormGroup,
    FormControlLabel,
    Box,
    Radio,
    Select,
    RadioGroup,
    Checkbox
} from "@mui/material";
import React, { useEffect, useState } from "react";
//import selecteddata from "../dpdata";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import axios from "axios";
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import HOST_URL from "../../../utils/Url";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import CustomLabel from "../../../CustomLable";
import api from "../../../utils/Url";
import { Language } from "react-transliterate";
import Languages from "../../../Languages";
import DeleteIcon from '@mui/icons-material/Delete';
import { getISTDate } from "../../../utils/Constant";
import selecteddata from "../../Empinfo/dpdata";
import moment from "moment";
import TranslateTextField from "../../../TranslateTextField";

type Props = {};


const unitOptions = [
    { value: 'Immediately', label: 'Immediately' },
    { value: 'Scheduled', label: 'Scheduled' },
    { value: 'Repeated', label: 'Repeated' },
    { value: 'Complete', label: 'Complete' },
];



const CreatemailcampgiontForm = (props: Props) => {
    const [status, setStatus] = useState('');
    const handleStatusChange = (event: any, newValue: any) => {
        setStatus(newValue?.value || '');
    };
    let navigate = useNavigate();
    const { t } = useTranslation();
    const [lang, setLang] = useState<Language>("en");
    // const [selectedValue, setSelectedValue] = useState('');
    const { defaultValues } = getISTDate();
    // const [ZoneOption, setZoneOption] = useState([{ value: "-1", label: t("text.SelectZone") }]);
    const [toaster, setToaster] = useState(false);
    const [toTime, setToTime] = useState<string>("");
    console.log('toTime', toTime)


    const [empOption, setempOption] = useState([
        { value: -1, label: t("text.empid") },
    ]);

    const [groupOption, setgroupOption] = useState([
        { value: -1, label: t("text.groupId") },
    ]);

    const [templateOption, setTemplateOpation] = useState([
        { value: -1, label: t("text.templateId") },
    ]);
    const formatTime = (date: Date) => {
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        return `${hours}:${minutes}:${seconds}`;
    };

    useEffect(() => {
        const currentTime = new Date();
        setToTime(formatTime(currentTime))
        //  getempData();
        getgroupData();
        getTemplateDta();
        getEmpData();
    }, []);


    // const getempData = async () => {
    //     const collectData = {
    //         "orderby": "",
    //         "pageNo": 0,
    //         "pageSize": 0,
    //         "intnotnullvalue1": 0,
    //         "userId": "",

    //         "str1": "",
    //         "str2": "",
    //         "str3": "",
    //         "str4": "",
    //         "str5": "",
    //         "intvalue1": 0,
    //         "intvalue2": 0,
    //         "intvalue3": 0,
    //         "intvalue4": 0,
    //         "intnotnullvalue2": 0,
    //         "intnotnullvalue3": 0,
    //         "dec1": 0,
    //         "dec2": 0,
    //         "dec3": 0,
    //         "dec4": 0,
    //         "flag": true,
    //         "data": "",
    //         "success": true,
    //         "error": "",
    //         "selectPerindex": 0,
    //         "show": true
    //     };
    //     const response = await api.post(`Employee/GetEmployee`, collectData);
    //     const data = response.data.data;
    //     const arr = [];
    //     for (let index = 0; index < data.length; index++) {
    //         arr.push({
    //             label: data[index]["empName"],
    //             value: data[index]["empid"],
    //         });
    //     }
    //     setempOption(arr);
    // };


    const getEmpData = async () => {
        const collectData = {
            orderby: "",
            pageNo: 0,
            pageSize: 0,
            intnotnullvalue1: 0,
            userId: "",
            str1: "",
            str2: "",
            str3: "",
            str4: "",
            str5: "",
            intvalue1: 0,
            intvalue2: 0,
            intvalue3: 0,
            intvalue4: 0,
            intnotnullvalue2: 0,
            intnotnullvalue3: 0,
            dec1: 0,
            dec2: 0,
            dec3: 0,
            dec4: 0,
            flag: true,
            data: "",
            success: true,
            error: "",
            selectPerindex: 0,
            show: true,
        };

        const response = await api.post(`Employee/GetEmployee`, collectData);
        const data = response.data.data;

        const arr = data.map((item: any) => ({
            label: item.empName,
            value: item.empid,
            email: item.email,
        }));

        setempOption([{ label: "Select All", value: "selectAll" }, ...arr]);
    };

    const handleChange = (event: any, newValue: any) => {
        let updatedList;

        if (newValue.some((option: any) => option.value === "selectAll")) {
            if (newValue.length === empOption.length) {
                // Deselect all
                updatedList = [];
            } else {
                // Select all
                updatedList = empOption.slice(1); // Exclude "Select All" from being selected
            }
        } else {
            updatedList = newValue;
        }

        const memberId = updatedList.map((item: any) => ({
            id: 0,
            campaignId: 0,
            groupId: 0,
            memberId: item.value,
            message: "",
            emailId: item.email,
            mobileNo: "",
            receiverType: "",
            name: "",
            isSelected: true,
        }));

        formik.setFieldValue("listMembers", memberId);
    };
    const getgroupData = async () => {
        const collectData = {
            "orderby": "",
            "pageNo": 0,
            "pageSize": 0,
            "intnotnullvalue1": 0,
            "userId": "",

            "str1": "",
            "str2": "",
            "str3": "",
            "str4": "",
            "str5": "",
            "intvalue1": 0,
            "intvalue2": 0,
            "intvalue3": 0,
            "intvalue4": 0,
            "intnotnullvalue2": 0,
            "intnotnullvalue3": 0,
            "dec1": 0,
            "dec2": 0,
            "dec3": 0,
            "dec4": 0,
            "flag": true,
            "data": "",
            "success": true,
            "error": "",
            "selectPerindex": 0,
            "show": true
        };
        const response = await api.post(`Comm/GetCommGroup`, collectData);
        const data = response.data.data;
        const arr = [];
        for (let index = 0; index < data.length; index++) {
            arr.push({
                label: data[index]["name"],
                value: data[index]["groupId"],
            });
        }
        setgroupOption(arr);
    };

    const getTemplateDta = async () => {
        const collectData = {
            "orderby": "",
            "pageNo": 0,
            "pageSize": 0,
            "intnotnullvalue1": 0,
            "userId": "",

            "str1": "",
            "str2": "",
            "str3": "",
            "str4": "",
            "str5": "",
            "intvalue1": 0,
            "intvalue2": 0,
            "intvalue3": 0,
            "intvalue4": 0,
            "intnotnullvalue2": 0,
            "intnotnullvalue3": 0,
            "dec1": 0,
            "dec2": 0,
            "dec3": 0,
            "dec4": 0,
            "flag": true,
            "data": "",
            "success": true,
            "error": "",
            "selectPerindex": 0,
            "show": true
        };
        const response = await api.post(`Comm/GetCampaignTemplate`, collectData);
        const data = response.data.data;
        const arr = [];
        for (let index = 0; index < data.length; index++) {
            arr.push({
                label: data[index]["template"],
                value: data[index]["templateId"],
            });

        }
        setTemplateOpation(arr);
    };

    const formik = useFormik({
        initialValues: {

            "campaignId": 0,
            "campaignName": "",
            "campaignDate": defaultValues,
            "campaignType": "",
            "tamplateId": 0,
            "message": "",
            "status": "",
            "fromDate": defaultValues,
            "toDate": defaultValues,
            "toTime": "",
            "createdBy": "",
            "updatedBy": "",
            "createdOn": defaultValues,
            "updatedOn": defaultValues,
            "listGroups": [],
            "listMembers": [],
            "srno": 0,
            "isExecute": true


        },

        validationSchema: Yup.object({
            campaignName: Yup.string()
                .required("Campaign Name is required")
                .min(2, "Campaign Name must be at least 2 characters")
                .max(50, "Campaign Name cannot exceed 50 characters"),

        }),
        onSubmit: async (values) => {

            values.toTime = toTime.toString();


            const response = await api.post(
                `Comm/UpsertCampaign`, values
                // { ...values, indentinv: validTableData }
            );
            console.log("to time", values)
            if (response.data.status === 1) {
                setToaster(false);
                toast.success(response.data.message);
                navigate("/emailsystem/emailcampaign");
            } else {
                setToaster(true);
                toast.error(response.data.message);
            }
        },
    });


    const back = useNavigate();


    return (
        <div>
            <div
                style={{
                    padding: "-5px 5px",
                    backgroundColor: "#ffffff",
                    borderRadius: "5px",
                    border: ".5px solid #FF7722",
                    marginTop: "3vh",
                }}
            >
                <CardContent>

                    <Grid item xs={12} container spacing={2} >

                        <Grid item lg={2} md={2} xs={2} marginTop={2}>
                            <Button
                                type="submit"
                                onClick={() => back(-1)}
                                variant="contained"
                                style={{
                                    backgroundColor: "blue",
                                    width: 20,
                                }}
                            >
                                <ArrowBackSharpIcon />
                            </Button>
                        </Grid>
                        <Grid item lg={7} md={7} xs={7} alignItems="center" justifyContent="center">
                            <Typography
                                gutterBottom
                                variant="h5"
                                component="div"
                                sx={{ padding: "20px" }}
                                align="center"
                            >
                                {t("text.SendEmail")}
                            </Typography>
                        </Grid>

                        <Grid item lg={3} md={3} xs={3} marginTop={3}>
                            <select
                                className="language-dropdown"
                                value={lang}
                                onChange={(e) => setLang(e.target.value as Language)}
                            >
                                {Languages.map((l) => (
                                    <option key={l.value} value={l.value}>
                                        {l.label}
                                    </option>
                                ))}
                            </select>
                        </Grid>
                    </Grid>
                    <Divider />
                    <br />
                    <form onSubmit={formik.handleSubmit}>
                        {toaster === false ? "" : <ToastApp />}
                        <Grid item xs={12} container spacing={2}>
                            {/* <Grid item lg={4} xs={12}>
                                <TextField
                                    id="campaignName"
                                    name="campaignName"
                                    label={
                                        <CustomLabel text={t("text.Emailcampaigname")} required={false} />
                                    }
                                    value={formik.values.campaignName}
                                    placeholder={t("text.Emailcampaigname")}
                                    size="small"
                                    fullWidth
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}

                                />
                            </Grid> */}


                            {/* <Grid item xs={12} lg={4}>
                                <TranslateTextField
                                    label={t("text.Emailcampaigname")}
                                    value={formik.values.campaignName}
                                    onChangeText={(text: string) => formik.setFieldValue("campaignName", text)}
                                    required={true}
                                    lang={lang}
                                />
                                {formik.touched.campaignName && formik.errors.campaignName ? (
                                    <div style={{ color: "red", margin: "5px" }}>
                                        {formik.errors.campaignName}
                                    </div>
                                ) : null}
                            </Grid> */}

                            <Grid item xs={12} lg={4}>
                                <TextField
                                    label={t("text.Emailcampaigname")}
                                    value={formik.values.campaignName}
                                    onChange={(e) => formik.setFieldValue("campaignName", e.target.value)}
                                    required={true}
                                    fullWidth
                                    size="small"
                                />
                                {formik.touched.campaignName && formik.errors.campaignName ? (
                                    <div style={{ color: "red", margin: "5px" }}>
                                        {formik.errors.campaignName}
                                    </div>
                                ) : null}
                            </Grid>

                            <Grid item xs={12} sm={4} lg={4}>
                                <TextField
                                    label={
                                        <CustomLabel
                                            text={t("text.Emailcampgiandate")}
                                            required={false}
                                        />
                                    }
                                    variant="outlined"
                                    fullWidth
                                    size="small"
                                    name="campaignDate"
                                    id="campaignDate"
                                    type="date"
                                    placeholder={t("text.Emailcampgiandate")}
                                    onChange={formik.handleChange}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>

                            <Grid item xs={12} sm={4} lg={4}>
                                <Autocomplete
                                    disablePortal
                                    id="combo-box-demo"
                                    options={unitOptions}
                                    fullWidth
                                    size="small"
                                    onChange={(event: any, newValue: any) => {
                                        formik.setFieldValue("status", newValue?.value.toString());
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={<CustomLabel text={t("text.SelectStatus")} required={false} />}
                                        />
                                    )}
                                />
                            </Grid>

                            {/* <Grid item lg={4} xs={12}>
                                <Autocomplete
                                    disablePortal
                                    id="combo-box-demo"
                                    options={templateOption}
                                    fullWidth
                                    size="small"
                                    onChange={(event: any, newValue: any) => {
                                        formik.setFieldValue("tamplateId", newValue?.value.toString());
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={<CustomLabel text={t("text.Template")} required={false} />}
                                        />
                                    )}
                                />
                            </Grid> */}




                            {/* <Grid item lg={4} xs={12}>
                                <TextField
                                    label={
                                        <CustomLabel
                                            text={t("text.Emailfromdate")}
                                            required={false}
                                        />
                                    }
                                    variant="outlined"
                                    fullWidth
                                    size="small"
                                    name="fromDate"
                                    id="fromDate"
                                    type="date"
                                    disabled
                                    placeholder={t("text.Emailfromdate")}
                                    onChange={formik.handleChange}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid> */}

                            <Grid item lg={4} xs={12}>
                                <TextField
                                    label={<CustomLabel text={t("text.Emailfromdate")} required={false} />}
                                    variant="outlined"
                                    fullWidth
                                    size="small"
                                    name="fromDate"
                                    type="date"
                                    disabled={formik.values.status !== "Scheduled"} // Enable only in "Scheduled" status
                                    placeholder={t("text.Emailfromdate")}
                                    onChange={formik.handleChange}
                                    InputLabelProps={{ shrink: true }}
                                    value={formik.values.fromDate}
                                />
                            </Grid>

                            {/* <Grid item lg={4} xs={12}>
                                <TextField
                                    label={
                                        <CustomLabel
                                            text={t("text.EmailtoDate")}
                                            required={false}
                                        />
                                    }
                                    variant="outlined"
                                    fullWidth
                                    size="small"
                                    name="toDate"
                                    id="toDate"
                                    type="date"
                                    disabled
                                    placeholder={t("text.EmailtoDate")}
                                    onChange={formik.handleChange}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid> */}

                            <Grid item lg={4} xs={12}>
                                <TextField
                                    label={<CustomLabel text={t("text.EmailtoDate")} required={false} />}
                                    variant="outlined"
                                    fullWidth
                                    size="small"
                                    name="toDate"
                                    type="date"
                                    disabled={formik.values.status !== "Scheduled"} // Enable only in "Scheduled" status
                                    placeholder={t("text.EmailtoDate")}
                                    onChange={formik.handleChange}
                                    InputLabelProps={{ shrink: true }}
                                    value={formik.values.toDate}
                                />
                            </Grid>





                            {/* <Grid item lg={4} xs={12}>
                                <TextField
                                    label={
                                        <CustomLabel
                                            text={t("text.toTime")}
                                            required={false}
                                        />
                                    }
                                    variant="outlined"
                                    fullWidth
                                    size="small"
                                    name="toTime"
                                    id="toTime"
                                    type="time"
                                    value={toTime}
                                    disabled
                                    onChange={(e) => {


                                        setToTime(e.target.value);
                                        // formik.setFieldValue("toTime", e.target.value); 
                                    }}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid> */}


                            {formik.values.status !== "Scheduled" && ( // Hide in "Scheduled" status
                                <Grid item lg={4} xs={12}>
                                    <TextField
                                        label={<CustomLabel text={t("text.toTime")} required={false} />}
                                        variant="outlined"
                                        fullWidth
                                        size="small"
                                        name="toTime"
                                        type="time"
                                        disabled={formik.values.status !== "Repeated"} // Enable only in "Repeated" status
                                        value={formik.values.toTime}
                                        onChange={(e) => {
                                            formik.setFieldValue("toTime", e.target.value);
                                        }}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>
                            )}
                            <Grid item lg={4} xs={12}>
                                <Autocomplete
                                    disablePortal
                                    id="combo-box-template"
                                    options={templateOption.map((option) => ({
                                        value: option.value.toString(),
                                        label: option.label,
                                    }))}
                                    fullWidth
                                    size="small"
                                    onChange={(event: any, newValue: { value: string; label: string } | null) => {
                                        formik.setFieldValue("tamplateId", newValue?.value || "");
                                        formik.setFieldValue("message", newValue?.label || "");
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={<CustomLabel text={t("text.Template")} required={false} />}
                                        />
                                    )}
                                />

                            </Grid>

                            {/* <Grid item xs={12} sm={4} lg={4}>
                                <Autocomplete
                                    disableCloseOnSelect
                                    multiple
                                    id="combo-box-demo"
                                    options={groupOption}
                                    fullWidth
                                    size="small"
                                    onChange={(event, newValue: any) => {

                                        const groupID = newValue.map((item: any) => ({
                                            "id": 0,
                                            "campaignId": 0,
                                            "groupId": item.value,
                                            "memberId": 0,
                                            "message": "",
                                            "emailId": "",
                                            "mobileNo": "",
                                            "receiverType": "",
                                            "name": "",
                                            "isSelected": true
                                        }));
                                        console.log("🚀 ~ serviceID ~ serviceID:", groupID);

                                        formik.setFieldValue("listGroups", groupID);

                                        console.log(newValue?.value);
                                        // formik.setFieldValue("listGroups", newValue?.label);
                                        // formik.setFieldValue("groupId", newValue?.value?.toString());
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={<CustomLabel text={t("text.listGroups")} />}
                                        />
                                    )}
                                />
                            </Grid> */}
                            <Grid item xs={12} sm={4} lg={4}>
                                <Autocomplete
                                    disableCloseOnSelect
                                    multiple
                                    id="combo-box-demo"
                                    options={groupOption}
                                    //getOptionLabel={(option: any) => option.label}
                                    fullWidth
                                    size="small"
                                    onChange={(event, newValue: any) => {
                                        const groupID = newValue.map((item: any) => ({
                                            id: 0,
                                            campaignId: 0,
                                            groupId: item.value,
                                            memberId: 0,
                                            message: "",
                                            emailId: "",
                                            mobileNo: "",
                                            receiverType: "",
                                            name: "",
                                            isSelected: true,
                                        }));
                                        console.log("🚀 ~ groupID:", groupID);

                                        formik.setFieldValue("listGroups", groupID);
                                    }}
                                    renderOption={(props, option, { selected }) => (
                                        <li {...props}>
                                            <Checkbox
                                                checked={selected}
                                                style={{ marginRight: 8 }}
                                            />
                                            {option.label}
                                        </li>
                                    )}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={<CustomLabel text={t("text.listGroups")} />}
                                        />
                                    )}
                                />
                            </Grid>


                            <Grid item xs={12} sm={4} lg={4}>
                                <Autocomplete
                                    disableCloseOnSelect
                                    multiple
                                    options={empOption}
                                    getOptionLabel={(option) => option.label} // Display the label
                                    fullWidth
                                    size="small"
                                    //  value={formik.values.listMembers || []}
                                    onChange={handleChange}
                                    renderOption={(props, option, { selected }) => (
                                        <li {...props} style={{ display: "flex", alignItems: "center" }}>
                                            <Checkbox
                                                checked={selected}
                                                style={{ marginRight: 8 }}
                                            />
                                            <span>{option.label}</span> {/* Ensure the label is displayed */}
                                        </li>
                                    )}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={<CustomLabel text={t("text.listMembers")} />}
                                        />
                                    )}
                                />
                            </Grid>

                            {/* <Grid item xs={12} sm={4} lg={4}>
            <Autocomplete
                disableCloseOnSelect
                multiple
                options={empOption}
                getOptionLabel={(option:any) => option.label}
                fullWidth
                size="small"
                value={formik.values.listMembers || []}
                onChange={handleChange}
                renderOption={(props, option, { selected }) => (
                    <li {...props}>
                        <Checkbox
                            checked={selected}
                            style={{ marginRight: 8 }}
                        />
                        <span>{option.label}</span>
                    </li>
                )}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={<CustomLabel text={t("text.listMembers")} />}
                    />
                )}
            />
        </Grid> */}

                            {/* <Grid item xs={12} sm={4} lg={4}>
                                <Autocomplete
                                    disableCloseOnSelect
                                    multiple
                                    id="combo-box-demo"
                                    options={empOption}
                                    fullWidth
                                    size="small"
                                    onChange={(event, newValue: any) => {
                                        const memberId = newValue.map((item: any) => ({

                                            "id": 0,
                                            "campaignId": 0,
                                            "groupId": 0,
                                            "memberId": item.value,
                                            "message": "",
                                            "emailId": "",
                                            "mobileNo": "",
                                            "receiverType": "",
                                            "name": "",
                                            "isSelected": true

                                        }));
                                        console.log("🚀 ~ serviceID ~ serviceID:", memberId);

                                        formik.setFieldValue("listMembers", memberId);

                                        console.log(newValue?.value);
                                        // formik.setFieldValue("listMembers", newValue?.label);
                                        // formik.setFieldValue("empid", newValue?.value?.toString());
                                    }}

                                    renderOption={(props, option, { selected }) => (
                                        <li {...props}>
                                            <Checkbox
                                                checked={selected}
                                                style={{ marginRight: 8 }}
                                            />
                                            {option.label}
                                        </li>
                                    )}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={<CustomLabel text={t("text.listMembers")} />}
                                        />
                                    )}
                                />
                            </Grid> */}

                            {/* <Grid item xs={12} sm={4} lg={4}>
                                <Autocomplete
                                    disableCloseOnSelect
                                    multiple
                                    id="combo-box-demo"
                                    options={[{ label: "Select All", value: "selectAll" }, ...empOption]}
                                    getOptionLabel={(option: any) => option.label}
                                    fullWidth
                                    size="small"
                                    value={formik.values.listMembers || []} // Set the selected values from Formik
                                    onChange={(event, newValue: any) => {
                                        if (newValue.some((item: any) => item.value === "selectAll")) {
                                            const memberId = empOption.map((item: any) => ({
                                                id: 0,
                                                campaignId: 0,
                                                groupId: 0,
                                                memberId: item.value,
                                                message: "",
                                                emailId: "",
                                                mobileNo: "",
                                                receiverType: "",
                                                name: "",
                                                isSelected: true,
                                            }));

                                            formik.setFieldValue("listMembers", memberId);
                                        } else {
                                            const memberId = newValue.map((item: any) => ({
                                                id: 0,
                                                campaignId: 0,
                                                groupId: 0,
                                                memberId: item.value,
                                                message: "",
                                                emailId: "",
                                                mobileNo: "",
                                                receiverType: "",
                                                name: "",
                                                isSelected: true,
                                            }));

                                            formik.setFieldValue("listMembers", memberId);
                                        }
                                    }}
                                    renderOption={(props, option, { selected }) => (
                                        <li {...props}>
                                            <Checkbox
                                                checked={
                                                    option.value === "selectAll"
                                                        ? formik.values.listMembers?.length === empOption.length
                                                        : selected
                                                }
                                            //   style={{ marginRight: 8 }}
                                            />
                                            {option.label}
                                        </li>
                                    )}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={<CustomLabel text={t("text.listMembers")} />}
                                        />
                                    )}
                                />
                            </Grid> */}


                            {/* <Grid item lg={4} xs={12}>
                                <Autocomplete
                                    disablePortal
                                    id="combo-box-demo"
                                    options={templateOption}
                                    fullWidth
                                    size="small"
                                    onChange={(event: any, newValue: any) => {
                                        formik.setFieldValue("tamplateId", newValue?.value.toString());
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={<CustomLabel text={t("text.Template")} required={false} />}
                                        />
                                    )}
                                />
                            </Grid>


                            <Grid item lg={12} xs={12}>
                                <TranslateTextField
                                    label={t("text.message")}
                                    value={formik.values.message}
                                    onChangeText={(text: string) => formik.setFieldValue("message", text)}
                                    required={false}
                                    lang={lang}
                                />
                                {formik.touched.message && formik.errors.message ? (
                                    <div style={{ color: "red", margin: "5px" }}>
                                        {formik.errors.message}
                                    </div>
                                ) : null}
                            </Grid> */}




                            <Grid item lg={12} xs={12}>
                                <TextField
                                    label={t("text.message")}
                                    value={formik.values.message}
                                    onChange={formik.handleChange}
                                    required={false}
                                    fullWidth
                                    size="small"
                                />
                                {formik.touched.message && formik.errors.message ? (
                                    <div style={{ color: "red", margin: "5px" }}>
                                        {formik.errors.message}
                                    </div>
                                ) : null}
                            </Grid>

                            <Grid item lg={6} sm={6} xs={12}>
                                <Button
                                    type="submit"
                                    fullWidth
                                    style={{
                                        backgroundColor: `var(--header-background)`,
                                        color: "white",
                                        marginTop: "10px",
                                    }}
                                >
                                    {t("text.save")}
                                </Button>
                            </Grid>
                            <Grid item lg={6} sm={6} xs={12}>
                                <Button
                                    type="reset"
                                    fullWidth
                                    style={{
                                        backgroundColor: "#F43F5E",
                                        color: "white",
                                        marginTop: "10px",
                                    }}
                                    onClick={(e: any) => formik.resetForm()}
                                >
                                    {t("text.reset")}
                                </Button>
                            </Grid>

                        </Grid>
                    </form>
                </CardContent>
            </div>
        </div>
    );
};

export default CreatemailcampgiontForm;
